import { useStore } from '@/hooks/useStore';
import { OptionOtherItem } from '@/types/option';
import { observer } from 'mobx-react-lite';
import { useState, useEffect } from 'react';
import { OptionComp, OptionCompProps } from '../OptionComp';
import { formatToCurrency } from '@/utils/formatNumber';
import { useTranslation } from 'react-i18next';

interface CancellationFeeProps {
    showTextDecoration?: boolean,
    showDescription?: boolean
}

export default observer(function CancellationFee({ showTextDecoration = true, showDescription = true }: CancellationFeeProps) {
    // hook
    const { t } = useTranslation();

    // state
    const [otherOptions, setOtherOptions] = useState<OptionCompProps[]>([]);

    // store
    const {
        generalStore: { cancelSetting }
    } = useStore();

    // lifecycle
    useEffect(() => {
        if (cancelSetting && cancelSetting?.cancelbooking) {
            const cancelbooking = cancelSetting?.cancelbooking;
            const currentOtherOption = [] as OptionCompProps[];
            let newOtherOption: OptionCompProps = {
                title: t('price_list.title_section.cancel'),
                data: [],
                textDecoration: showTextDecoration ? t('price_list.text_decoration.cancel') : undefined,
                isSameSize: true,
                descriptionList: showDescription ? [t('sentences.cancel_des_1'), t('sentences.cancel_des_2')] : undefined,
                specialNote: [t('sentences.price_contain_tax')]
            };
            let dataOption: OptionOtherItem[] = [];
            if (cancelbooking.cancel72h) {
                dataOption = [...dataOption, {
                    fieldName: t('price_list.cancel_milestone_1', { 'hours': 72 }),
                    value: formatToCurrency(cancelbooking.cancel72h.toString()) + t('currency.currency_unit')
                }];
            }
            if (cancelbooking.cancelBefore72h) {
                dataOption = [...dataOption, {
                    fieldName: t('price_list.cancel_milestone_2', { 'from': 48, 'to': 72 }),
                    value: cancelbooking.cancelBefore72h + '%'
                }];
            }
            if (cancelbooking.cancelBefore48h) {
                dataOption = [...dataOption, {
                    fieldName: t('price_list.cancel_milestone_3', { 'from': 0, 'to': 48 }),
                    value: cancelbooking.cancelBefore48h + '%'
                }];
            }
            if (dataOption.length > 0) {
                newOtherOption.data = dataOption;
                currentOtherOption.push(newOtherOption);
            }

            setOtherOptions(currentOtherOption);
        }

        return () => {
            setOtherOptions([]);
        };
    }, [cancelSetting]);

    return (
        <>
            {
                otherOptions.length > 0 && otherOptions.map((item, idx) => (
                    <OptionComp option={item} key={idx} />
                ))
            }
        </>
    );
});
